import React from 'react'
import HeroHeader from '../layout/HeroHeader'
import Packages from '../components/Packages'

const AllPackages = () => {
  return (
    <>
        
    <HeroHeader title={'Our Packages'}/>
    <Packages />
    
    </>
  )
}

export default AllPackages